/*******************************************************************************
 * Copyright     : Copyright (c)  2020 Honeywell Inc. All rights reserved.
 *                 This work contains trade secrets and confidential materials
 *                 of Honeywell Inc., and its use or disclosure in whole or in
 *                 part without express written permission of Honeywell Inc.
 *                 is prohibited.
 *
 * Name          : apiTypes.ts
 *
 * Project Title : APM Settings Tool
 *
 * Description   : API Redux Middleware actions
 *
 *
 * Company       : Honeywell Technology Solutions , Hyderabad
 *
 * @Author       : H422335
 *
 * @Date         : December 16, 2021
 *
 * @Version      : Version 1.0
 *
 * By            : <Author>
 * On            : <Date>
 * Description   : <Description>
 *
 *
 ******************************************************************************/

import { createAction } from "@reduxjs/toolkit";
import { AxiosRequestConfig } from "axios";

/* eslint-disable @typescript-eslint/ban-types */
export interface IAPIPayload {
  url: string;
  params?: Object;
  data?: Object;
  responseType?: string;
  onStart?: string;
  onSuccess?: string;
  onError?: string;
  showGlobalError?: boolean;
  method?: AxiosRequestConfig["method"];
}
/* eslint-enable @typescript-eslint/ban-types */

export const apiCallBegan = createAction(
  "api/callBegan",
  function prepare(payload: IAPIPayload) {
    return {
      payload,
    };
  }
);
export const apiCallSuccess = createAction("api/callSuccess");
export const apiCallFailed = createAction("api/callFailed");
